"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var js_brand_1 = require("@giphy/js-brand");
var react_2 = __importDefault(require("react"));
var bouncer = (0, react_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n     to {\n    transform: scale(1.75) translateY(-20px);\n  }\n"], ["\n     to {\n    transform: scale(1.75) translateY(-20px);\n  }\n"])));
var loaderHeight = 37;
var Container = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    height: ", "px;\n    padding-top: 15px;\n    margin: 0 auto;\n    text-align: center;\n    justify-content: center;\n    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;\n"], ["\n    display: flex;\n    align-items: center;\n    height: ", "px;\n    padding-top: 15px;\n    margin: 0 auto;\n    text-align: center;\n    justify-content: center;\n    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;\n"])), loaderHeight);
var Dot = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    height: 10px;\n    width: 10px;\n    margin: ", "px 10px 10px 10px;\n    position: relative;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);\n    animation: ", " cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;\n    background: ", ";\n    animation-delay: ", ";\n"], ["\n    display: inline-block;\n    height: 10px;\n    width: 10px;\n    margin: ", "px 10px 10px 10px;\n    position: relative;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);\n    animation: ", " cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;\n    background: ", ";\n    animation-delay: ", ";\n"])), loaderHeight, bouncer, function (props) {
  return props.color;
}, function (props) {
  return props.delay;
});
var Loader = function Loader(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b;
  return react_2.default.createElement(Container, {
    className: className
  }, react_2.default.createElement(Dot, {
    color: js_brand_1.giphyGreen,
    delay: "0"
  }), react_2.default.createElement(Dot, {
    color: js_brand_1.giphyBlue,
    delay: ".1s"
  }), react_2.default.createElement(Dot, {
    color: js_brand_1.giphyPurple,
    delay: ".2s"
  }), react_2.default.createElement(Dot, {
    color: js_brand_1.giphyRed,
    delay: ".3s"
  }), react_2.default.createElement(Dot, {
    color: js_brand_1.giphyYellow,
    delay: ".4s"
  }));
};
exports.default = Loader;
var templateObject_1, templateObject_2, templateObject_3;